var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
import { useMemo, createRef } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
export default function DrawerNorth() {
    var widgets = useAppSelector(function (state) { return state.layout.slots[Slot.DRAWER_NORTH].widgets; });
    var widgetRefs = useMemo(function () { return widgets.map(function (widget) { return ({ widget: widget, nodeRef: createRef() }); }); }, [widgets]);
    return (_jsx("div", __assign({ className: "absolute bg-[var(--colors-drawer-bg)]\n      mt-[var(--margin-mt-drawer-north)] mr-[var(--margin-mr-drawer-north)]\n      mb-[var(--margin-mb-drawer-north)] ml-[var(--margin-ml-drawer-north)]\n      ".concat(widgets.length > 0
            ? "z-[10] border rounded-sm  shadow-[0_2px_20px_0px_rgba(0,0,0,0.3)]"
            : "hidden", " w-full flex-none drawer-north direction-horizontal transition-all max-h-[calc(100%-4rem)]") }, { children: _jsx("div", __assign({ className: "w-full overflow-auto scroll-elements" }, { children: _jsx(TransitionGroup, __assign({ className: "widgets-list w-full pb-10 overflow-auto" }, { children: widgetRefs.map(function (_a) {
                    var widget = _a.widget, nodeRef = _a.nodeRef;
                    return (_jsx(CSSTransition, __assign({ timeout: 500, nodeRef: nodeRef, classNames: "slide-down" }, { children: _jsx("div", __assign({ ref: nodeRef, className: " relative" }, { children: _jsx("div", __assign({ className: "widgets w-full pt-0 pr-0 pb-[2rem] pl-0 border-none overflow-hidden shadow-[#4a4a4a]" }, { children: widgets.map(function (widget) { return (_jsx(WidgetDisplay, { widget: widget }, widget.id)); }) })) })) }), widget.id));
                }) })) })) })));
}
